function OnLayoutChange(element, callback) {
  let layoutName = "desktop";

  let handler = function () {
    let newLayoutName = window.innerWidth < 1024 ? "mobile" : "desktop";
    if (newLayoutName != layoutName) {
      callback(newLayoutName);
    }
    layoutName = newLayoutName;
  };

  let initLayoutName = window.innerWidth < 1024 ? "mobile" : "desktop";
  callback(initLayoutName);

  window.addEventListener("resize", handler);

  return {
    destroy() {
      window.removeEventListener("resize", handler);
    },
  };
}

export { OnLayoutChange };
